import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../config/supabase';

const ResetPassword = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validSession, setValidSession] = useState(false);

  useEffect(() => {
    // Check if we have a valid password recovery session
    checkSession();
  }, []);

  const checkSession = async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        setValidSession(true);
      } else {
        setError('Invalid or expired reset link. Please request a new one.');
      }
    } catch (err) {
      console.error('Session check error:', err);
      setError('An error occurred. Please try again.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }

    setLoading(true);

    try {
      const { error: updateError } = await supabase.auth.updateUser({
        password: password
      });

      if (updateError) throw updateError;

      setSuccess(true);
      
      // Redirect to login after 3 seconds
      setTimeout(() => {
        navigate('/login');
      }, 3000);
      
    } catch (err) {
      console.error('Password reset error:', err);
      setError(err.message || 'Failed to reset password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <div className="page-wrapper">
        <div className="logo-container" style={{textAlign: 'center', marginBottom: '2rem'}}>
          <img src="/images/IBVlogo.png" alt="IBV Wealth Club" style={{maxWidth: '150px', height: 'auto'}} />
        </div>

        <div className="card">
          <h2 className="section-title text-center">Set New Password</h2>

          {success ? (
            <div className="alert alert-success">
              <i className="fas fa-check-circle" style={{marginRight: '8px'}}></i>
              Password updated successfully! Redirecting to login...
            </div>
          ) : (
            <>
              {error && <div className="alert alert-error">{error}</div>}

              {validSession && (
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label className="form-label">New Password</label>
                    <input
                      type="password"
                      className="form-input"
                      placeholder="Enter new password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      minLength={6}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Confirm New Password</label>
                    <input
                      type="password"
                      className="form-input"
                      placeholder="Confirm new password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                      minLength={6}
                    />
                  </div>

                  <button 
                    type="submit" 
                    className="btn btn-primary" 
                    disabled={loading}
                  >
                    {loading ? 'Updating...' : 'Update Password'}
                  </button>

                  <button 
                    type="button" 
                    className="btn btn-secondary mt-md"
                    onClick={() => navigate('/login')}
                  >
                    Back to Login
                  </button>
                </form>
              )}

              {!validSession && !error && (
                <div style={{textAlign: 'center', padding: '2rem'}}>
                  <div className="loading-spinner"></div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
